import { useCallback, useEffect, useRef, useState } from 'react'

export const DEFAULT_RESEND_COOLDOWN_SECONDS = 60

export function useResendCooldown(initialSeconds = 0) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds)
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current)
    }
  }, [])

  const clearCooldown = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current)
    timerRef.current = null
    setSecondsLeft(0)
  }, [])

  const startCooldown = useCallback((seconds = DEFAULT_RESEND_COOLDOWN_SECONDS) => {
    setSecondsLeft(seconds)
    if (timerRef.current) clearInterval(timerRef.current)
    timerRef.current = setInterval(() => {
      setSecondsLeft((current) => {
        if (current <= 1) {
          if (timerRef.current) clearInterval(timerRef.current)
          timerRef.current = null
          return 0
        }
        return current - 1
      })
    }, 1000)
  }, [])

  return {
    secondsLeft,
    startCooldown,
    clearCooldown,
    isBlocked: secondsLeft > 0,
  }
}
